import React, { useEffect, useState } from 'react';
import './workouts.css';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Header from "../../components/Header/Header";
import {
    changeWorkoutCoachSagaAction,
    changeWorkoutDateSagaAction,
    changeWorkoutTypeSagaAction,
    removeWorkoutSagaAction,
    saveKeyNumberSagaAction,
    updateWorkoutCostSagaAction
} from "../../redux/sagaActions";
import { GetWorkoutsThunk } from "../../redux/thunks/GetWorkoutsThunk";
import Pagination from "../../components/Pagination/Pagination";
import WorkoutsHeader from "../../components/PagesHeaders/WorkoutsHeader/WorkotusHeader";
import OneTimeWorkoutForm from "../../components/OneTimeWorkoutForm/OneTimeWorkoutForm";
import { contextAction, keyNumberAction, searchAction, selectAction, setWorkoutPaymentFormAction } from "../../redux/rootReducer";
import ContextMenu from "../../components/ContextMenu/ContextMenu";
import Select from "../../components/Select/Select";
import { SELECT_INITIAL, WORKOUT_PAYMENT_FORM_INITIAL } from "../../redux/initialStateConstant";
import CalendarOffline from "../../components/CalendarOffline/CalendarOffline";
import WorkoutPaymentForm from "../../components/WorkoutPaymentForm/WorkoutPaymentForm";
import Tippy from "@tippyjs/react";

const Workouts = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const workouts = useSelector(state => state.workouts);
    const all_workouts_count = useSelector(state => state.all_workouts_count);
    const oneTimeWorkoutForm = useSelector(state => state.oneTimeWorkoutForm);
    const filterDate = useSelector(state => state.filterDate);
    const filterTypesOptions = useSelector(state => state.filterTypesOptions);
    const filterCoachesOptions = useSelector(state => state.filterCoachesOptions);
    const filterOneTimeWorkout = useSelector(state => state.filterOneTimeWorkout);
    const filterConstraintsOptions = useSelector(state => state.filterConstraintsOptions);
    const filterWorkoutsCountOptions = useSelector(state => state.filterWorkoutsCountOptions);
    const filterUser = useSelector(state => state.filterUser);
    const subscription_coaches = useSelector(state => state.subscription_coaches);
    const subscription_types = useSelector(state => state.subscription_types);
    const key_number = useSelector(state => state.key_number);
    const context = useSelector(state => state.context);
    const workout_payment_form = useSelector(state => state.workout_payment_form);

    // Редактирование стоимости тренировки
    const [cost, setCost] = useState({ workout_id: '', value: '' });

    // Состояние открытого календаря
    const [changeWorkoutDateCalendar, setChangeWorkoutDateCalendar] = useState(null);

    // Функция смены страницы
    const changePage = page => {
        dispatch(GetWorkoutsThunk({
            page,
            from: filterDate.from,
            to: filterDate.to,
            subscription_type: JSON.stringify(filterTypesOptions.filter(el => el.active).map(el => el.id)),
            subscription_coach: JSON.stringify(filterCoachesOptions.filter(el => el.active).map(el => el.id)),
            subscription_constraints: JSON.stringify(filterConstraintsOptions.filter(el => el.active).map(el => el.id)),
            subscription_workouts_count: JSON.stringify(filterWorkoutsCountOptions.filter(el => el.active).map(el => el.id)),
            filter_user: filterUser.user.id,
            oneTime: filterOneTimeWorkout
        }));
    };

    let data = null;
    if (workouts?.length  && context) {
        data = workouts.find(elem => elem.id === context);
    }

    const menu = [
        {
            id: '1',
            caption: 'Доплата за тренировку',
            handler: () => {
                dispatch(setWorkoutPaymentFormAction({
                    ...WORKOUT_PAYMENT_FORM_INITIAL,
                    open: true,
                    workout_id: data.id
                }));
                dispatch(contextAction(false));
            }
        },
        {
            id: '2',
            caption: 'Удалить тренировку',
            handler: () => {
                if (window.confirm('Вы действительно хотите удалить тренировку?')) {
                    dispatch(removeWorkoutSagaAction({
                        workout_id: data.id
                    }));
                }
                dispatch(contextAction(false));
            }
        }
    ];

    useEffect(() => {

        if (!currentEstablishment) return;

        dispatch(GetWorkoutsThunk({ page: 1 }));
    }, [currentEstablishment]);

    return (
        <>
            <Header component={ <WorkoutsHeader/> }/>
            { oneTimeWorkoutForm.open && <OneTimeWorkoutForm/> }
            { workout_payment_form.open && <WorkoutPaymentForm/> }
            <div className="page">
                <div className="page__content">
                    <div className="table__header">
                        <div className="workouts__count">{ `Всего тренировок: ${ all_workouts_count }` }</div>
                        <div className="table__caption workouts__caption">Тренировки</div>
                    </div>
                    <div className="table">
                        <div className="table__row table__row--header workouts__line">
                            <div className="table__cell table__cell--left">Имя</div>
                            <div className="table__cell">Тип тренировки</div>
                            <div className="table__cell">Занятие</div>
                            <div className="table__cell">Дата</div>
                            <div className="table__cell">Начало</div>
                            <div className="table__cell">Конец</div>
                            <div className="table__cell">Тренер</div>
                            <div className="table__cell">Ключ</div>
                            <div className="table__cell">Сумма</div>
                            <div className="table__cell"/>
                        </div>
                        {
                            workouts.map(elem => {
                                return (
                                    <div key={ elem.id } className="table__row workouts__line">
                                        <ContextMenu data={{
                                            open: elem.id === context,
                                            style: { right: 28 },
                                            menu
                                        }}/>
                                        <div className="table__cell table__cell--left table__cell--hover"
                                             onClick={ () => {
                                                 if (!elem.user_id) return;

                                                 // Очищаем поиск
                                                 dispatch(searchAction(''));
                                                 // Переходим в карточку клиента
                                                 history.push('/fitness/users/' + elem.user_id);
                                             } }
                                        >
                                            { elem.user }
                                            {
                                                elem.user &&
                                                <Tippy content={ 'Открыть в новой вкладке' }>
                                                    <div className="user__tab"
                                                         onClick={ event => {
                                                             event.preventDefault();
                                                             event.stopPropagation();

                                                             window.open('/fitness/users/' + elem.user_id, '_blank', 'noopener,noreferrer');
                                                         } }
                                                    />
                                                </Tippy>
                                            }
                                        </div>
                                        <Select
                                            cell={ true }
                                            current={ elem.type }
                                            type={ 'change_type' + elem.id }
                                            options={ subscription_types }
                                            handler={ type => {
                                                dispatch(changeWorkoutTypeSagaAction({
                                                    workout_id: elem.id,
                                                    type_id: type.id
                                                }));
                                                dispatch(selectAction(SELECT_INITIAL));
                                            } }
                                            smart={ true }
                                        />
                                        <div className="table__cell">{ elem.workout_count === 'Разовое' ? <div style={{ color: 'var(--main-color)' }}>Разовое</div> : elem.workout_count }</div>
                                        <div className="table__cell table__cell--hover table__cell--no-overflow"
                                            onClick={ event => {
                                                event.preventDefault();
                                                event.stopPropagation();
                                                if (event.target.closest('.calend')) return;
                                                setChangeWorkoutDateCalendar(elem.id);
                                            } }
                                        >
                                            <CalendarOffline
                                                date={ elem.date_not_formatted }
                                                handler={ date => {
                                                    setChangeWorkoutDateCalendar(null);
                                                    dispatch(changeWorkoutDateSagaAction({
                                                        workout_id: elem.id,
                                                        date
                                                    }));
                                                } }
                                                open={ changeWorkoutDateCalendar === elem.id }
                                                close={ () => setChangeWorkoutDateCalendar(null) }
                                                style={{ margin: '34px auto 0 auto', left: 0, right: 0 }}
                                            />
                                            { elem.date }
                                        </div>
                                        <div className="table__cell">{ elem.start }</div>
                                        <div className="table__cell">{ elem.finish }</div>
                                        <Select
                                            cell={ true }
                                            current={ elem.coach }
                                            type={ 'change_coach' + elem.id }
                                            options={ subscription_coaches }
                                            handler={ coach => {
                                                dispatch(changeWorkoutCoachSagaAction({
                                                    workout_id: elem.id,
                                                    coach_id: coach.id
                                                }));
                                                dispatch(selectAction(SELECT_INITIAL));
                                            } }
                                            smart={ true }
                                        />
                                        <input type="text" className="table__cell input input--cell"
                                               value={ key_number.workout_id === elem.id ? key_number.number : elem.key_number }
                                               onInput={ event => dispatch(keyNumberAction({
                                                   ...key_number,
                                                   workout_id: elem.id,
                                                   number: event.target.value
                                               })) }
                                               onBlur={ () => {
                                                   // Сохраняем номер ключа, только если было изменение номера
                                                   if (key_number.workout_id) {
                                                       dispatch(saveKeyNumberSagaAction({
                                                           key_number: key_number.number,
                                                           workout_id: key_number.workout_id,
                                                           update: 'workouts'
                                                       }));
                                                   }
                                               } }
                                        />
                                        <input type="text" className="table__cell input input--cell"
                                               value={ cost.workout_id === elem.id ? cost.value : elem.cost }
                                               onInput={ event => setCost({ workout_id: elem.id, value: event.target.value }) }
                                               onBlur={ () => {
                                                   if (!cost.workout_id) return;
                                                   // Сохраняем стоимость тренировки
                                                   dispatch(updateWorkoutCostSagaAction({
                                                       workout_id: cost.workout_id,
                                                       cost: cost.value
                                                   }));
                                               } }
                                        />
                                        <i className="menu__button" onClick={ event => {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            dispatch(contextAction(elem.id));
                                        } }/>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
                <Pagination handler={ changePage }/>
            </div>
        </>
    );
};

export default Workouts;